export type CategoryType =
  | "EDUCATIONAL_RESOURCE"
  | "EXTERNAL_PROVIDERS"
  | "COLORS"
  | "MISSED_REASON_APPT"
  | "APPOINTMENT_REASON"
  | "REIMBURSEMENT_REASON";

export type CategoryStatus = "ACTIVE" | "INACTIVE";

export type CategoryLanguageCode = "en-US" | "en-GB" | "es-419";

export const CATEGORY_LANGUAGE_CODES: CategoryLanguageCode[] = [
  "en-US",
  "en-GB",
  "es-419",
];

// Stored category data predates the backend normalization and may carry any
// casing ("en-us", "en-GB", ...). This maps any stored value to the canonical
// enum the Categories UI operates on. Returns undefined for unknown codes so
// callers can decide how to handle them.
export const normalizeCategoryLanguageCode = (
  raw: string | undefined | null
): CategoryLanguageCode | undefined => {
  if (!raw) return undefined;
  const lower = raw.replace("_", "-").toLowerCase();
  return CATEGORY_LANGUAGE_CODES.find(
    (code) => code.toLowerCase() === lower
  );
};

export interface CategoryLanguage {
  language: CategoryLanguageCode;
  name: string;
  description?: string;
}

export interface CategoryItem {
  _id?: string;
  languages: CategoryLanguage[];
  icon?: string;
  hexaColor?: string;
  textColor?: string;
  status?: CategoryStatus;
}

// Persisted shape — server-returned items always carry an _id.
export interface CategoryElement extends Omit<CategoryItem, "_id"> {
  _id: string;
}

export type Language = CategoryLanguage;

export interface Category {
  _id: string;
  accountId: string;
  type?: CategoryType;
  status?: CategoryStatus;
  phoneNumber?: string;
  categories: CategoryElement[];
  createdAt?: string;
  updatedAt?: string;
  createdBy?: string;
  updatedBy?: string;
  isDeleted?: boolean;
}
